export default __webpack_public_path__ + "6f5d3d2c344ee59cce35364aca962abd.jpg";